module.exports = __webpack_public_path__ + "img/faytech_technische-zeichnung.3485fba8.png";